import React, { useEffect, useState } from 'react';
import CreateCustomer from './Createcistomer';
import CustomerMgtList from './CustomerMgtList';
import { toast } from "../../../components/AppToast";
import { saveCustomerAPI } from '../../../services/customer/customer';
import { updateCustomerAPI } from '../../../services/customer/customer';
export default function CustManagement() {
    const [customer, setCustomerdata] = useState()
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null); // view/edit

    const [listVersion, setListVersion] = useState();
    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };


    const submitForm = async (formData, id) => {
        try {
            if (id) {

                const updateDate = await updateCustomerAPI(formData, id);
                if (updateDate.success == true) {
                    toast.success("Customer updated successfully");
                    closeForm();
                    setListVersion(v => v + 1);
                }
                else {
                    toast.error('Customer updation failed')
                }
            }
            else {

                const getesult = await saveCustomerAPI(formData);

                if (getesult.success == true) {
                    toast.success("Customer created successfully");
                    closeForm();
                    setListVersion(v => v + 1);

                }
                else {
                    toast.error('customer creation failed')
                }
            }

        }
        catch (err) {
            throw err;
        }
    }

    return (


        <div className="card shadow-lg main-card">

            {/* ---------- HEADER ---------- */}
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Customer Management"
                        : isCreating
                            ? "Create Customer Mgt "
                            : activeRecord?.mode === "edit"
                                ? "Edit Customer Mgt"
                                : "View Customer Mgt"}
                </h4>
            </div>


            {/* ---------- BREADCRUMBS ---------- */}
            {onlyFormVisible && (
                <nav
                    aria-label="breadcrumb"
                    className="px-3 py-2 border-bottom bg-light"
                >
                    <ol
                        className="breadcrumb mb-0 align-items-center"
                        style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
                    >
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Customer Management
                            </button>
                        </li>

                        <li
                            className="breadcrumb-item active fw-semibold text-primary"
                            aria-current="page"
                        >
                            {isCreating
                                ? "Create Customer Mgt"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Customer Mgt"
                                    : "View Customer Mgt"}
                        </li>
                    </ol>
                </nav>
            )}



            <div className="card-body">
                {!onlyFormVisible ? (
                    <CustomerMgtList
                        refreshKey={listVersion}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) =>
                            setActiveRecord({ mode: "view", data: row })
                        }
                        onEdit={(row) =>
                            setActiveRecord({ mode: "edit", data: row })
                        }
                    />
                ) : (


                    <CreateCustomer
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />
                )}
            </div>
        </div>
    );
};


